export const getUserIP = async (): Promise<string> => {
    try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        return data.ip;
    } catch (error) {
        console.error("Failed to fetch IP:", error);
        return "127.0.0.1"; // Fallback to localhost if fetch fails
    }
};